import React, { useState } from 'react';
import ReactTable from 'react-table'
import ReactTooltip from 'react-tooltip'
import {
    courierWithInstantPickup,
    courierWithNotes,
    normalizeCourierServices
} from "../../services/helpers/courier";
import numeral from "numeral";
import InputLocation from "../atoms/InputLocation";

const UploadStoreOrderTable = props => {
    const columns = [{
        Header: 'NO',
        Cell: ({row,original}) => numberCell(row._index+1,original),
        maxWidth: 75,
        style: { 'whiteSpace': 'unset'},
        className:'text-center',
        headerClassName: 'text-center'
    },{
        Header: 'PENGIRIMAN',
        minWidth: 200,
        Cell: ({row,original})  => destinationCell(row,original),
    },{
        Header: 'BARANG',
        style: { 'whiteSpace': 'unset'},
        Cell: ({row,original})  => itemCell(original)
    },{
        Header: 'KURIR',
        Cell: ({row,original})  => courierCell(original),
    },{
        Header: 'HARGA PENGIRIMAN',
        Cell: ({row,original})  => priceCell(original),
    },{
        Header: 'EDIT',
        maxWidth: 75,
        Cell: ({row,original})  => actionCell(row,original),
    }];

    const numberCell = (idx,o) => {
        let priceView;
        let value = true;
        if (!o.price) {
            value = false
        } else if (!(o.originName && o.originPhone)) {
            value = false 
        } else if (!(o.receiverName && o.receiverPhone)) {
            value = false 
        }

        if (value) {
            priceView = <b style={{'color':'#000000'}}>✅ Siap</b>
        } else {
            priceView =  <b style={{'color':'#000000'}}>❌ Belum Siap </b>
        }
        return (
             <div>
                <p>{idx}</p>
                 {priceView}
             </div>
        )
    };

    const destinationCell = (r,o) => {
        const idx = r._index;
        let originMapView, destinationMapView;

        return (
            <div>
                <span className="badge badge-shopify">SHOPIFY ORDER ID: {o.shopifyOrderId}</span>
                <div className="pl-3">
                    <div className="row">       
                        <div className="col-1 px-0">
                            <span className="text-primary">
                                <i className="fas fa-map-marker-alt mt-1"/>
                            </span>
                        </div>
                        <div className="col-11 pl-0">
                            <strong>{o.originName}</strong> <br/>
                            {o.originPhone} <br/>
                            <div>
                                {o.originLocation}<br/>
                                <i>{o.originPostalCode}</i>
                            </div>
                        </div>
                    </div>
                    <div className="py-1"/>
                    <div className="row">
                        <div className="col-1 px-0">
                          <span className="text-danger">
                              <i className="fas fa-map-marker-alt mt-1"/>
                          </span>
                        </div>
                        <div className="col-11 pl-0">
                            <strong>{o.receiverName}</strong> <br/>
                            {o.receiverPhone ? 
                                <div>{o.receiverPhone}<br/></div> : ""}
                            <div>
                                {o.receiverLocation}<br/>
                                <i>{o.receiverPostalCode}</i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    };

    const itemCell = (og) => {
        let { orderItems } = og;
       
        return (
            <div>
                <small>LIST BARANG</small>
                { orderItems.map((i,idx) => (
                    <div key={idx} className="rounded p-2 mb-1 border shadow--hover">
                        <small><b>{i.quantity}x - {i.name}</b></small><br/>
                        <small>Rp. {numeral(i.value).format("0,0")} <br/></small>
                        <small>{i.weight} gram</small>
                    </div>
                ))}
            </div>
        )
        
    };

    const courierCell = (o) => {
        const { companyName,typeView } = normalizeCourierServices(o.courierCompany,o.courierType);
        if (o.error) {
            return (
                <span className="badge badge-danger">
                Layanan Tidak Terdaftar
                </span>
            )
        }
        return (
            <div>
                {companyName} - {typeView}
            </div>
        )
    };

    const priceCell = (o) => {
        return (
            <div>
                <b>Rp. {numeral(o.price).format("0,0")}</b><br/>
            </div>
        )
    }

    const actionCell = (r,o) => {
        const idx = r._index;
        return (
            <div className="mb-2 pointer">
                <a onClick={() => props.onRemoveStoreOrder(idx)}
                   className="action-item mr-2"
                   title="Trash">
                    <i className="fas fa-trash"></i>
                </a><br/>
                <small>HAPUS</small>
            </div>
        )
    }

    return (
        <div>
            <ReactTable
                data={props.data}
                columns={columns}
                defaultPageSize={props.data.length}
                loading={props.loading}
                showPagination={false}
                className="-striped -highlight"
            />
        </div>
    )
};

export default UploadStoreOrderTable;
